let shopData = [
  {
    id: 1,
    name: "Sugat",
    brand: "Betsin Maalat",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat placeat similique dicta nulla praesentium deserunt. Corporis repellendus deleniti dolores eligendi.",
    price: 56,
    img: "https://firebasestorage.googleapis.com/v0/b/salinaka-ecommerce.appspot.com/o/products%2Figsz61dwpUgqT51Qd1F7?alt=media&token=db2f442f-4c92-4175-b21a-be6a448bc501",
    size: [28, 36, 42],
    color: [
      "rgb(0, 0, 0)",
      "rgb(197, 0, 197)",
      "rgb(132, 3, 9)",
      "rgb(0, 77, 132)",
      "rgb(117, 54, 0)",
      "rgb(0, 240, 224)",
      "rgb(19, 247, 2)",
    ],
    // colorName: [
    //   "Black",
    //   "Yellow",
    //   "Red",
    //   "Blue",
    //   "rgb(117, 54, 0)",
    //   "rgb(0, 240, 224)",
    //   "rgb(19, 247, 2)",
    // ],
    added: false,
    parameter: "igsz61dwpUgqT51Qd1F7",
  },
  {
    id: 2,
    name: "Kulangot",
    brand: "Salt",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat placeat similique dicta nulla praesentium deserunt. Corporis repellendus deleniti dolores eligendi.",
    price: 67,
    img: "https://firebasestorage.googleapis.com/v0/b/salinaka-ecommerce.appspot.com/o/products%2FYIZuxWur1W4fAT6z3ejk?alt=media&token=7dca264f-c345-4cfc-93a8-60217a53f66a",
    size: [28, 36, 42],
    color: [
      "rgb(0, 0, 0)",
      "rgb(197, 0, 197)",
      "rgb(132, 3, 9)",
      "rgb(0, 77, 132)",
      "rgb(117, 54, 0)",
      "rgb(255, 238, 0)",
      "rgb(0, 240, 8)",
    ],
    added: false,
    parameter: "YIZuxWur1W4fAT6z3ejk",
  },
  {
    id: 3,
    name: "Tiktilaok Manok",
    brand: "Sexbomb",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat placeat similique dicta nulla praesentium deserunt. Corporis repellendus deleniti dolores eligendi.",
    price: 78,
    img: "https://firebasestorage.googleapis.com/v0/b/salinaka-ecommerce.appspot.com/o/products%2FbS1hHdO7NvbR1yN5ZPlR?alt=media&token=809a3249-f83d-4aec-b134-34a65ce2ce10",
    size: [28, 36, 42],
    color: [
      "rgb(0, 0, 0)",
      "rgb(197, 0, 197)",
      "rgb(132, 3, 9)",
      "rgb(0, 77, 132)",
      "rgb(117, 54, 0)",
    ],
    added: false,
    parameter: "bS1hHdO7NvbR1yN5ZPlR",
  },
  {
    id: 4,
    name: "Very Nice",
    brand: "Salt Maalat",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat placeat similique dicta nulla praesentium deserunt. Corporis repellendus deleniti dolores eligendi.",
    price: 79,
    img: "https://firebasestorage.googleapis.com/v0/b/salinaka-ecommerce.appspot.com/o/products%2FLIu8tS4yHSU28Xi8BXCj?alt=media&token=31e796ad-dbd6-4e4f-a8a9-192f5158684a",
    size: [28, 36, 42],
    color: [
      "rgb(0, 0, 0)",
      "rgb(197, 0, 197)",
      "rgb(132, 3, 9)",
      "rgb(0, 77, 132)",
      "rgb(117, 54, 0)",
      "rgb(3, 215, 252)",
      "rgb(12, 228, 26)",
    ],
    parameter: "LIu8tS4yHSU28Xi8BXCj",
  },
  {
    id: 5,
    name: "Quake Overload",
    brand: "Salt",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat placeat similique dicta nulla praesentium deserunt. Corporis repellendus deleniti dolores eligendi.",
    price: 80,
    img: "https://firebasestorage.googleapis.com/v0/b/salinaka-ecommerce.appspot.com/o/products%2FcLGc3mcbZrK3Tl3yJ3xW?alt=media&token=44f74e92-f2ca-4af3-82f6-7a3bcace7f7a",
    size: [28, 36, 42],
    color: [
      "rgb(0, 0, 0)",
      "rgb(197, 0, 197)",
      "rgb(132, 3, 9)",
      "rgb(0, 77, 132)",
      "rgb(117, 54, 0)",
      "rgb(3, 215, 252)",
      "rgb(12, 228, 26)",
    ],
    added: false,
    parameter: "cLGc3mcbZrK3Tl3yJ3xW",
  },
  {
    id: 6,
    name: "Kutu",
    brand: "Sexbomb",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat placeat similique dicta nulla praesentium deserunt. Corporis repellendus deleniti dolores eligendi.",
    price: 129,
    img: "https://firebasestorage.googleapis.com/v0/b/salinaka-ecommerce.appspot.com/o/products%2Fc0cvo2QXFMX1wO7EpvQC?alt=media&token=7115b501-723c-4fd3-9c00-e709ad38bd8a",
    size: [28, 36, 42],
    color: [
      "rgb(0, 0, 0)",
      "rgb(197, 0, 197)",
      "rgb(132, 3, 9)",
      "rgb(0, 77, 132)",
      "rgb(117, 54, 0)",
    ],
    added: false,
    parameter: "c0cvo2QXFMX1wO7EpvQC",
  },
  {
    id: 7,
    name: "Tuluk",
    brand: "Black Kibal",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat placeat similique dicta nulla praesentium deserunt. Corporis repellendus deleniti dolores eligendi.",
    price: 142,
    img: "https://firebasestorage.googleapis.com/v0/b/salinaka-ecommerce.appspot.com/o/products%2FJzaakhGgN8w2AU2My470?alt=media&token=92c7e2f7-77b4-416c-b415-5842418c3dc0",
    size: [28, 36, 42],
    color: [
      "rgb(0, 0, 0)",
      "rgb(197, 0, 197)",
      "rgb(0, 77, 132)",
      "rgb(117, 54, 0)",
      "rgb(40, 240, 0)",
      "rgb(255, 10, 10)",
    ],
    added: false,
    parameter: "JzaakhGgN8w2AU2My470",
  },
  {
    id: 8,
    name: "Takla Green",
    brand: "Sexbomb",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat placeat similique dicta nulla praesentium deserunt. Corporis repellendus deleniti dolores eligendi.",
    price: 150,
    img: "https://firebasestorage.googleapis.com/v0/b/salinaka-ecommerce.appspot.com/o/products%2FmrkQoZV2qlpaRWsonHtH?alt=media&token=374fabb7-24e8-4355-bc88-70fec1c2d60d",
    size: [28, 36, 42],
    color: [
      "rgb(0, 0, 0)",
      "rgb(197, 0, 197)",
      "rgb(132, 3, 9)",
      "rgb(0, 77, 132)",
      "rgb(117, 54, 0)",
    ],
    added: false,
    parameter: "mrkQoZV2qlpaRWsonHtH",
  },
  {
    id: 9,
    name: "Balakubak",
    brand: "Betsin Maalat",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat placeat similique dicta nulla praesentium deserunt. Corporis repellendus deleniti dolores eligendi.",
    price: 170,
    img: "https://firebasestorage.googleapis.com/v0/b/salinaka-ecommerce.appspot.com/o/products%2FYZ7LM3vZjWbIIJH2tgEb?alt=media&token=5e722063-a792-4502-9f6e-c3df1581aa9c",
    size: [28, 36, 42],
    color: [
      "rgb(0, 0, 0)",
      "rgb(197, 0, 197)",
      "rgb(132, 3, 9)",
      "rgb(0, 77, 132)",
      "rgb(117, 54, 0)",
    ],
    added: false,
    parameter: "YZ7LM3vZjWbIIJH2tgEb",
  },
  {
    id: 10,
    name: "Pitaklan",
    brand: "Black Kibal",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat placeat similique dicta nulla praesentium deserunt. Corporis repellendus deleniti dolores eligendi.",
    price: 174,
    img: "https://firebasestorage.googleapis.com/v0/b/salinaka-ecommerce.appspot.com/o/products%2FaubOenOJu42CNp4zXTLX?alt=media&token=1d5fd281-b9cc-499b-94a5-225273b1eabc",
    size: [28, 36, 42],
    color: [
      "rgb(247, 73, 64)",
      "rgb(36, 245, 88)",
      "rgb(232, 249, 1)",
      "rgb(47, 53, 244)",
    ],
    added: false,
    parameter: "aubOenOJu42CNp4zXTLX",
  },
  {
    id: 11,
    name: "Burnikk",
    brand: "Sexbomb",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat placeat similique dicta nulla praesentium deserunt. Corporis repellendus deleniti dolores eligendi.",
    price: 240,
    img: "https://firebasestorage.googleapis.com/v0/b/salinaka-ecommerce.appspot.com/o/products%2F7l3FMZqY8JdfssalDgx2?alt=media&token=be15689c-e12c-4829-9d78-32395ef1e3f7",
    size: [28, 36, 42],
    color: [
      "rgb(0, 0, 0)",
      "rgb(197, 0, 197)",
      "rgb(0, 77, 132)",
      "rgb(117, 54, 0)",
      "rgb(247, 8, 8)",
      "rgb(9, 225, 182)",
      "rgb(255, 111, 0)",
    ],
    added: false,
    parameter: "7l3FMZqY8JdfssalDgx2",
  },
  {
    id: 12,
    name: "Sipon Malapot",
    brand: "Salt",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat placeat similique dicta nulla praesentium deserunt. Corporis repellendus deleniti dolores eligendi.",
    price: 250,
    img: "https://firebasestorage.googleapis.com/v0/b/salinaka-ecommerce.appspot.com/o/products%2FYjDAQSbkSZlartelhFyV?alt=media&token=9b0bdd5e-eb91-4d99-a52f-298c12879fa3",
    size: [28, 36, 42],
    color: [
      "rgb(0, 0, 0)",
      "rgb(197, 0, 197)",
      "rgb(132, 3, 9)",
      "rgb(0, 77, 132)",
      "rgb(117, 54, 0)",
    ],
    added: false,
    parameter: "YjDAQSbkSZlartelhFyV",
  },
  {
    id: 13,
    name: "Buldit",
    brand: "Salt Maalat",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat placeat similique dicta nulla praesentium deserunt. Corporis repellendus deleniti dolores eligendi.",
    price: 250,
    img: "https://firebasestorage.googleapis.com/v0/b/salinaka-ecommerce.appspot.com/o/products%2FYVPdTsyxJybMCsdKpXhq?alt=media&token=23d7673c-a0bf-4dcb-89f1-8482446b56be",
    size: [28, 36, 42],
    color: ["rgb(202, 80, 247)", "rgb(45, 72, 210)", "rgb(255, 141, 10)"],
    added: false,
    parameter: "YVPdTsyxJybMCsdKpXhq",
  },
  {
    id: 14,
    name: "Merry Christmas",
    brand: "Salt Maalat",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat placeat similique dicta nulla praesentium deserunt. Corporis repellendus deleniti dolores eligendi.",
    price: 259,
    img: "https://firebasestorage.googleapis.com/v0/b/salinaka-ecommerce.appspot.com/o/products%2FzxNR1gLeEDPA5KXUtGmo?alt=media&token=dd5c69fd-6c69-47c2-8a50-2447ed0c9ca2",
    size: [28, 36, 42],
    color: ["rgb(236, 169, 24)"],
    added: false,
    parameter: "zxNR1gLeEDPA5KXUtGmo",
  },
  {
    id: 15,
    name: "Tilis Malaput",
    brand: "Betsin Maalat",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat placeat similique dicta nulla praesentium deserunt. Corporis repellendus deleniti dolores eligendi.",
    price: 340,
    img: "https://firebasestorage.googleapis.com/v0/b/salinaka-ecommerce.appspot.com/o/products%2FvEjSLuZ2zyCwln0LHv4K?alt=media&token=6b79fe0a-e7fa-4f23-a521-e6bad01032d0",
    size: [28, 36, 42],
    color: [
      "rgb(0, 0, 0)",
      "rgb(197, 0, 197)",
      "rgb(132, 3, 9)",
      "rgb(0, 77, 132)",
      "rgb(117, 54, 0)",
    ],
    added: false,
    parameter: "vEjSLuZ2zyCwln0LHv4K",
  },
  {
    id: 16,
    name: "Merry Christmas",
    brand: "Salt Maalat",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat placeat similique dicta nulla praesentium deserunt. Corporis repellendus deleniti dolores eligendi.",
    price: 365,
    img: "https://firebasestorage.googleapis.com/v0/b/salinaka-ecommerce.appspot.com/o/products%2Fs3uuRu71Mon65lHohQZ1?alt=media&token=6298fb20-91d4-461a-af78-90a404f89cd7",
    size: [28, 36, 42],
    color: ["rgb(223, 22, 22)"],
    added: false,
    parameter: "s3uuRu71Mon65lHohQZ1",
  },
  {
    id: 17,
    name: "Tilapia",
    brand: "Salt Maalat",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat placeat similique dicta nulla praesentium deserunt. Corporis repellendus deleniti dolores eligendi.",
    price: 450,
    img: "https://firebasestorage.googleapis.com/v0/b/salinaka-ecommerce.appspot.com/o/products%2FkEq31Ad5RBwmqOebNBqA?alt=media&token=75307fe0-2f8b-4a78-a82a-a4996b5ca94e",
    size: [28, 36, 42],
    color: [
      "rgb(0, 0, 0)",
      "rgb(197, 0, 197)",
      "rgb(132, 3, 9)",
      "rgb(0, 77, 132)",
      "rgb(117, 54, 0)",
    ],
    added: false,
    parameter: "kEq31Ad5RBwmqOebNBqA",
  },
  {
    id: 18,
    name: "Kibal Batal",
    brand: "Kibal Black",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat placeat similique dicta nulla praesentium deserunt. Corporis repellendus deleniti dolores eligendi.",
    price: 674,
    img: "https://firebasestorage.googleapis.com/v0/b/salinaka-ecommerce.appspot.com/o/products%2FALz5M4DI7MF7CdZrq3gS?alt=media&token=8d33ea34-2de3-466b-9b3d-27015e9cd540",
    size: [28, 36, 42],
    color: [
      "rgb(0, 0, 0)",
      "rgb(197, 0, 197)",
      "rgb(0, 77, 132)",
      "rgb(117, 54, 0)",
      "rgb(253, 138, 8)",
      "rgb(255, 82, 183)",
    ],
    added: false,
    parameter: "ALz5M4DI7MF7CdZrq3gS",
  },
];

export default function shareShop() {
  return shopData;
}

export function getData(productId) {
  return shopData.filter((item) => item.parameter == productId)[0];
}
